import { styled } from '@innowise-group/mui-kit';

export const Header = styled.div`
  ${({ theme }) => theme.fonts.primary[90]}
  color: ${({ theme }) => theme.palette.general.darkGrey[60]};
`;

export const Title = styled.div`
  ${({ theme }) => theme.fonts.primary[60]}
  line-height: 22px;
  margin-bottom: 10px;
  color: ${({ theme }) => theme.palette.general.darkGrey[100]};
`;

export const Description = styled.div`
  ${({ theme }) => theme.fonts.primary[40]}
  color: ${({ theme }) => theme.palette.general.darkGrey[80]};
  max-width: 500px;
`;

export const Author = styled.span`
  margin: 0 3px;
  ${({ theme }) => theme.fonts.primary[60]}
`;
